<template>
  <div class="batch-edit add-page">
    <div>
      <el-form v-if="form" :model="form" :disabled="form.status==3" ref="form" label-width="120px" :hide-required-asterisk="false">
        <div @keyup.enter.stop="save()">
          <el-form-item label="考试名称" prop="batchName" :rules="[$validate.fileName(30)]">
            <el-input v-model="form.batchName" :maxlength="30" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="考试logo" prop="batchImageUrl" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-upload class="inline-block" style="margin-left: 10px;" action="" :http-request="uploadOSS" :show-file-list="false" accept=".png,.jpg,.gif">
              <el-button type="default" style="color: #1890FF;margin-left: 0px;">上传文件</el-button>
            </el-upload>
            <span style="color: #666666;">说明：图片尺寸为：300px X 200px。仅支持JPG、PNG、GIF格式图片文件，且文件大小小于2MB</span>
            <el-input class="none" type="text" v-model="form.batchImageUrl" :maxlength="1024"></el-input>
            <div v-if="form.batchImageUrl2">
              <el-image :src="form.batchImageUrl2" :preview-src-list="[form.batchImageUrl2]" class="border" style="height: 100px;margin-top: 10px;"></el-image>
            </div>
          </el-form-item>
          <el-form-item label="考试级别" prop="gradeIds" :rules="[{required: false, message: '请选择', trigger: 'check'}]">
            <el-tree ref="tree" :data="treeData" node-key="categoryId" show-checkbox default-expand-all :expand-on-click-node="false" :indent="10"
                     :props="{label:'categoryName'}" :default-checked-keys="form.gradeIds" @check="form.gradeIds = Tool.getTreeIds($refs.tree, 'categoryId')">
              <template slot-scope="scope">
                <div class="inline-block" :class="scope.node.level==4?'node-leaf':'node-leaf-no'">
                  {{scope.node.label}}
                </div>
              </template>
            </el-tree>
            <div class="clearfix"></div>
          </el-form-item>
          <el-form-item label-width="140px" label="是否允许考级模拟" prop="isCanMock" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.isCanMock" :disabled="form.status>=2">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否限制考级点" prop="isAllAgent" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.isAllAgent" :disabled="form.status>=2">
              <el-radio v-for="(item,key) in $enums.boolean2" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="!form.isAllAgent" class="choseCity">
            <el-form-item label="" prop="agentIds" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
              <div style="color: #666666;">请选择能进行报名的承办单位</div>
              <el-cascader-panel
                v-model="form.agentIds"
                :options="agentTreeData"
                :props="{multiple:true}"
                clearable
              ></el-cascader-panel>
            </el-form-item>
          </div>
          <el-form-item label="默认报名时间" prop="enrollTime" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-date-picker v-model="form.enrollTime" format="yyyy-MM-dd HH:mm" :default-time="['00:00:00','23:59:00']" value-format="timestamp"
                            type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <div style="color: #666666;">考试专业默认使用此报名时间，考试专业单独编辑时以编辑的时间为准</div>
          </el-form-item>
          <el-form-item label="默认考试时间" prop="examTime" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-date-picker v-model="form.examTime" :picker-options="pickerOptionsDate" format="yyyy-MM-dd HH:mm" :default-time="['00:00:00','23:59:00']" value-format="timestamp"
                            type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="准考证开放时间" prop="admissionOpenTime" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-date-picker v-model="form.admissionOpenTime" type="datetime" format="yyyy-MM-dd HH:mm" placeholder="选择日期"></el-date-picker>
            <!--            <span>不设置默认报名开始时间</span>-->
          </el-form-item>
          <el-form-item label="报名期间是否允许考生申请退报名费" label-width="250px" prop="canRefundEnrollFee" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.canRefundEnrollFee" @change="checkExpress">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="考后是否允许考生申请证书快递退费" label-width="250px" prop="canRefundExpressFee" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.canRefundExpressFee" @change="checkExpress">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.canRefundExpressFee" label="申请退费时间" prop="refundExpressTime" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-date-picker v-model="form.refundExpressTime" :picker-options="pickerOptionsDate2" format="yyyy-MM-dd HH:mm" :default-time="['00:00:00','23:59:00']" value-format="timestamp"
                            type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="是否同步考试报名时间" label-width="165px" prop="isSyncTime" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.isSyncTime">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="省外考生报考是否需要审核" label-width="190px" prop="needResidencePermit" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.needResidencePermit">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <div>基本费用设置</div>
          <div class="flex-middle" style="margin-top: 10px;color: #666666;">
            <div style="width: 200px;margin-right: 10px">费用名称</div>
            <div style="width: 110px;margin-right: 10px">具体费用</div>
          </div>
          <template v-if="Tool.isNull(form.examFeeList) && form.status<2">
            <i class="icon icon_add-circle pointer" @click="addFee()" style="font-size: 30px;"></i>
          </template>
          <template v-else>
            <div v-for="(item,i) in form.examFeeList" :key="i" class="flex-middle" style="margin-top: 10px;">
              <el-form-item label="" label-width="0px" :prop="'examFeeList.'+i+'.feeType'" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
                <el-select :disabled="form.status>=2" v-model="item.feeType" placeholder="请选择费用" @change="getfeeName(item,i)" filterable clearable style="width: 200px;margin-right:10px;">
                  <el-option v-for="(item,index) in Tool.map2arr($enums.feeType)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
                </el-select>
                <!--                <el-input v-model="item.examFeeName" :disabled="form.status>=2" maxlength="20" placeholder="请输入费用名称" style="width: 200px;margin-right: 10px;"></el-input>-->
              </el-form-item>
              <el-form-item label="" label-width="0px" :prop="'examFeeList.'+i+'.examFee'" :rules="[$validate.number(true)]">
                <el-input v-model="item.examFee" :disabled="form.status>=2" @input="e=>item.examFee=Tool.checkNumber(e,1000,2)" placeholder="请输入" style="width: 110px;margin-right: 10px;"></el-input>
              </el-form-item>
              <div v-if="form.status<2" style="width: 60px;margin-bottom: 22px;">
                <i v-if="i==form.examFeeList.length-1" class="icon icon_add-circle pointer" @click="addFee(i)" style="font-size: 30px;"></i>
                <i class="icon icon_minus-circle pointer" @click="delFee(i)" style="font-size: 30px;"></i>
              </div>
            </div>
          </template>
          <el-form-item label="机构是否可进行考级时间调整" label-width="220px" prop="isTimeAdjust" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.isTimeAdjust" :disabled="form.status>=2">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.isTimeAdjust" label="机构是否必填准考证开放时间" label-width="220px" prop="needAdmissionOpenTime" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.needAdmissionOpenTime" :disabled="form.status>=2">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="机构是否可进行考级费用调整" label-width="220px" prop="isFeeAdjust" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.isFeeAdjust" :disabled="form.status>=2">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="form.isFeeAdjust">
            <div class="flex-middle">
              <el-form-item label="机构考级费用上调比例" label-width="200px" prop="feeLowerRate" :rules="[$validate.integer(false)]">
                <el-input v-model="form.feeLowerRate" :disabled="form.status>=2" maxlength="3" @input="e=>form.feeLowerRate=Tool.checkNumber(e,100)" placeholder="" style="width: 110px;"></el-input>
              </el-form-item>
              <div style="padding: 2px 10px;margin-top: -15px;">% 至</div>
              <el-form-item label-width="0px" prop="feeUpperRate" :rules="[$validate.integer(true)]">
                <el-input v-model="form.feeUpperRate" :disabled="form.status>=2" maxlength="3" @input="e=>form.feeUpperRate=Tool.checkNumber(e,100)" placeholder="" style="width: 110px;"></el-input>
              </el-form-item>
              <div style="padding: 2px 10px;margin-top: -15px;color: #666666;">% 只能填写整数</div>
            </div>
            <div style="color: #666666;">上浮比例只包含考试级别费用，不包含考试基本费用</div>
          </div>
          <el-form-item label-width="210px" label="考试是否在APP中显示" prop="isShowApp" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.isShowApp">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label-width="210px" label="考试是否在小程序中显示" prop="isShowSmallApp" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.isShowSmallApp">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--          <el-form-item label="考生曲目选择时间" label-width="140px" prop="chooseQuestionStep" :rules="[{required: true, message: '请选择', trigger: 'change'}]">-->
          <!--            <el-radio-group v-model="form.chooseQuestionStep" :disabled="form.status>=2">-->
          <!--              <el-radio v-for="(item,key) in $enums.chooseQuestionStep" :key="key" :label="Number(key)">{{item}}</el-radio>-->
          <!--            </el-radio-group>-->
          <!--          </el-form-item>-->
        </div>
      </el-form>
    </div>
    <div class="text-right add-bottom fixed">
      <el-button size="medium" @click="$router.push({path:'/batch/batch',query:$route.query})">取消</el-button>
      <el-button v-if="form && form.status<3" size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: [],
  data () {
    return {
      form: {
        isSyncTime: 0,
        agentIds: [],
        chooseQuestionStep: 1,
        isShowApp: 1
      },
      treeData: [],
      agentTreeData: [],
      pickerOptionsDate: {
        disabledDate: (time) => {
          if (this.form.enrollTime) {
            return time.getTime() < new Date(this.form.enrollTime[0]).getTime();
          }
        }
      }
    }
  },
  async created () {
    await this.initForm()
    await this.getTreeData()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    validateDate (rule, value, callback) {
      if (this.form.status < 2) {
        if (this.Tool.limitDateTime(value[0], value[1])) {
          if (this.$moment(value[0]).isBefore(this.$moment(value[1]))) {
            callback()
          } else {
            callback(new Error('开始时间必须小于结束时间'))
          }
        } else {
          callback(new Error('请选择当前时间之后的时间'))
        }
      } else if (this.form && this.form.timeLimit) {
        let limitMinStartTime = this.form.timeLimit.enrollStartTime
        let limitMinEndTime = this.form.timeLimit.enrollEndTime
        let minDateTime = this.Tool.getMinDateTime(this.$moment(), this.form.enrollStartTime)
        if (this.Tool.limitDateTime(value[0], value[1], minDateTime, '3000-01-01 00:00:00', limitMinStartTime, limitMinEndTime)) {
          if (this.$moment(value[0]).isBefore(this.$moment(value[1]))) {
            callback()
          } else {
            callback(new Error('开始时间必须小于结束时间'))
          }
        } else {
          callback(new Error(`时间必须包含${limitMinStartTime}与${limitMinEndTime}之间的时间,且开始时间在${this.$moment(minDateTime).format('YYYY-MM-DD HH:mm')}之后`))
        }
      }
    },
    disabledDate (curr) {
      return this.$moment(curr).isBefore(this.$moment(this.Tool.getMinDateTime(this.$moment(), this.form.enrollStartTime)).add(-1, 'day'))
    },
    // disabledDate2 (curr) {
    //   return this.$moment(curr).isBefore(this.$moment(this.Tool.getMinDateTime(this.$moment(), this.form.enrollEndTime)).add(-1, 'day'))
    // },
    async uploadOSS (event) {
      try {
        if (event.file.size > 1024 * 1024 * 2) {
          throw new Error('仅支持JPG、PNG、GIF格式图片文件，且文件大小小于2MB')
        }
        // let imageSize = await this.Tool.getImageSize(event.file)
        // if (imageSize.width !== 300 || imageSize.height !== 200) {
        //   throw new Error('图片尺寸必须为：300px X 200px')
        // }
        this.form.batchImageUrl = await this.$HTTP.ApiOss.uploadOSS(event.file, `logo`, '.png,.jpg,.gif', 'public-read')
        this.form.batchImageUrl2 = await this.$HTTP.ApiOss.signatureUrl(this.form.batchImageUrl, 'public-read')
        this.$forceUpdate()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async addFee (i) {
      if (this.Tool.isNull(i)) {
        this.form.examFeeList.push({})
      } else {
        let isOK = await this.Tool.checkForm(this.$refs['form'], [`examFeeList.${i}.examFeeName`, `examFeeList.${i}.examFee`,`examFeeList.${i}.feeType`])
        if (isOK) {
          this.form.examFeeList.splice(Number(i) + 1, 0, {})
        }
      }
    },
    delFee (i) {
      this.form.examFeeList.splice(i, 1)
    },
    rendNode () {
      let leafs = document.getElementsByClassName('node-leaf-no')
      for (let i = 0; i < leafs.length; i++) {
        let leaf = leafs[i]
        leaf.parentElement.parentElement.style.cssText = 'clear:both;'
        // leaf.parentElement.parentElement.parentElement.style.cssText = 'clear:both;'
      }
    },
    async getfeeName(event,index) {
      for (let i in this.form.examFeeList) {
        let fee = this.form.examFeeList[index]
        this.Tool.map2arr(this.$enums.feeType).map(item =>{
          if (item.key == event.feeType) {
            fee.examFeeName = item.value
          }
        })
      }
    },
    async getTreeData () {
      let treeData = await this.$HTTP.ApiCategory.getTreeData()
      let allTreeData = [{ categoryId: '0', categoryLevel: 0, categoryName: '全选', children: treeData }]
      setTimeout(() => {
        this.rendNode()
      }, 0)
      for (let i in allTreeData[0].children) {
        let t1 = allTreeData[0].children[i]
        if (this.Tool.isNull(t1.children)) {
          setTimeout(() => {
            this.$router.replace(`/platform/category?currentNodeIndex=${i}`)
          }, 2000)
          throw new Error(`${t1.categoryName}下没有专业和级别信息，请返回专业分类管理，完善专业分类信息`)
        } else {
          for (let j in t1.children) {
            let t2 = t1.children[j]
            if (this.Tool.isNull(t2.children)) {
              setTimeout(() => {
                this.$router.replace(`/platform/category?currentNodeIndex=${i}`)
              }, 2000)
              throw new Error(`${t2.categoryName}下没有级别信息，请返回专业分类管理，完善专业分类信息`)
            }
          }
        }
      }
      return allTreeData
    },
    async initForm () {
      let allTreeData = await this.getTreeData()
      let agentTreeData = await this.$HTTP.ApiAgent.getAgentTreeData()
      if (this.$route.query.batchId) {
        let info = await this.$HTTP.ApiBatch.getInfo(this.$route.query.batchId)
        info.isTimeAdjust = this.Tool.isNull(info.isTimeAdjust) ? 0 : info.isTimeAdjust
        info.batchImageUrl2 = await this.$HTTP.ApiOss.signatureUrl(info.batchImageUrl, 'public-read')
        info.enrollTime = [this.$moment(info.enrollStartTime), this.$moment(info.enrollEndTime)]
        info.examTime = [this.$moment(info.examStartTime), this.$moment(info.examEndTime)]
        info.refundExpressTime = [this.$moment(info.refundExpressStartTime), this.$moment(info.refundExpressEndTime)]
        info.gradeIds = this.Tool.joinList(info.gradeList, 'categoryId')
        // if (info.isAllAgent) {
        //   info.agentIds = []
        // }
        let hasPublish = false
        this.Tool.walkTree(allTreeData, (node) => {
          for (let i in info.gradeList) {
            let item = info.gradeList[i]
            if (item.categoryId === node.categoryId && item.status === Number(2)) {
              node.disabled = true
              hasPublish = true
            }
          }
        })
        if (hasPublish) {
          let agentIds = info.agentIds
          let ids = []
          agentIds.forEach(el => {
            ids.push([el.parentAddress, el.address, el.agentId])
          })
          info.agentIds = ids
        } else {
          if (info.agentIds) {
            let agentIds = info.agentIds
            let ids = []
            agentIds.forEach(el => {
              ids.push([el.parentAddress, el.address, el.agentId])
            })
            info.agentIds = ids
          }
        }
        if (this.Tool.isNull(info.examFeeList)) {
          info.examFeeList = []
        }
        this.form = info
        this.$set(this.form, 'isSyncTime', 0)
      } else {
        let info = {
          status: 0,
          examFeeList: [{}],
          isAllAgent: 0,
          isTimeAdjust: 0,
          isFeeAdjust: 0,
          needAdmissionOpenTime: 0,
          chooseQuestionStep: 1,
          batchImageUrl: '',
          isSyncTime: 0,
          isCanMock: 1,
          needResidencePermit: 0,
          canRefundExpressFee: 1,
          canRefundEnrollFee: 1,
          isShowApp: 1,
          isShowSmallApp: 1
        }
        this.form = info
      }
      this.agentTreeData = agentTreeData
      if (this.form.agentIds) {
        this.form.agentIds.map(el => {
          // 第一层数据
          this.agentTreeData.map(item => {
            // 第二层数据渲染
            item.children.map(o => {
              // 第三层数据渲染
              if (o.children) {
                const infoIndex = o.children.findIndex(c => c.value === el[2])
                if (this.form.status == 2 && infoIndex != -1) {
                  // debugger
                  this.$set(o.children[infoIndex], 'disabled', true);
                }
              }
            })
          })
        })
      }

      this.treeData = allTreeData
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    checkExpress () {
      if (!this.form.canRefundExpressFee) {
        this.form.refundExpressTime = []
      }
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        let gradeIds = this.Tool.getTreeIds(this.$refs.tree, 'categoryId')
        if (gradeIds.length === 0) {
          throw new Error('请选择级别')
        }
        if (this.form.isFeeAdjust) {
          if (Number(this.form.feeUpperRate) <= Number(this.form.feeLowerRate)) {
            throw new Error('费用上调比例下限必须小于上调比例上线')
          }
        } else {
          this.form.feeLowerRate = null
          this.form.feeUpperRate = null
        }
        let checkedNodes = this.$refs.tree.getCheckedNodes(false, true)
        let specialtyIds = []
        for (let i in checkedNodes) {
          if (checkedNodes[i].categoryLevel === 2) {
            specialtyIds.push(checkedNodes[i].categoryId)
          }
        }
        this.form.specialtyIds = specialtyIds
        this.form.gradeIds = gradeIds
        this.form.enrollStartTime = this.form.enrollTime[0]
        this.form.enrollEndTime = this.form.enrollTime[1]
        this.form.examStartTime = this.form.examTime[0]
        this.form.examEndTime = this.form.examTime[1]
        this.form.refundExpressStartTime = this.form.refundExpressTime[0]
        this.form.refundExpressEndTime = this.form.refundExpressTime[1]
        let agentIds = this.form.agentIds
        let ids = []
        if (agentIds) {
          agentIds.forEach(item => {
            ids.push(item[item.length - 1])
          })
        }
        if (this.form.batchId) {
          await this.$HTTP.ApiBatch.edit({ ...this.form, agentIds: ids })
        } else {
          await this.$HTTP.ApiBatch.add({ ...this.form, agentIds: ids })
        }
        this.$router.push('/batch/batch')
      }
    }
  }
}
</script>
<style>
  .batch-edit .el-tree-node {
    float: left;
  }

  .batch-edit .el-tree-node__content {
    cursor: default;
  }
</style>
